<template>
  <div>
  <Card class="p-shadow-1">
        <template #title>
            Configurar
        </template>
        <template #content>            
            <p><strong>Selecione as posições das colunas dos campos obrigatórios.</strong> </p>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-1">
                    <label>Nome</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaNome" :options="posicoesColunas" optionLabel="pos" 
                    optionValue="valor" @change="validarColuna('posicaoColunaNome')"/>
                </div>
                <div class="p-field p-col-12 p-md-1">
                    <label>Pis</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaPis" :options="posicoesColunas" optionLabel="pos" 
                    optionValue="valor" @change="validarColuna('posicaoColunaPis')"/>
                </div>
                <div class="p-field p-col-12 p-md-1">
                    <label>Cpf</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaCpf" :options="posicoesColunas" optionLabel="pos" 
                    optionValue="valor" @change="validarColuna('posicaoColunaCpf')"/>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>Crachá</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaCracha" :options="posicoesColunas" optionLabel="pos" 
                    optionValue="valor" @change="validarColuna('posicaoColunaCracha')"/>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>Registro</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaRegistro" :options="posicoesColunas" optionLabel="pos" 
                    optionValue="valor" @change="validarColuna('posicaoColunaRegistro')"/>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>Data de Admissão</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaDataAdmissao" :options="posicoesColunas" optionLabel="pos" 
                    optionValue="valor" @change="validarColuna('posicaoColunaDataAdmissao')"/>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>Cargo</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaCargo" :options="posicoesColunas" optionLabel="pos" 
                    optionValue="valor" @change="validarColuna('posicaoColunaCargo')"/>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>Centro de Custo</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaCentroCusto" :options="posicoesColunas" optionLabel="pos" 
                    optionValue="valor" @change="validarColuna('posicaoColunaCentroCusto')"/>
                </div>
            </div>
            <div class="p-mt-3 p-mb-3">
                <label><strong>Opcional</strong></label>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-2">
                    <label>Senha Biometria</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaSenhaBiometria" :options="posicoesColunas" optionLabel="pos" optionValue="valor"/>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>Data de Nascimento</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaDataNascimento" :options="posicoesColunas" optionLabel="pos" optionValue="valor"/>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>E-mail</label>
                    <Dropdown v-model="colunasFuncionario.posicaoColunaEmail" :options="posicoesColunas" optionLabel="pos" optionValue="valor"/>
                </div>               
            </div>
            <div class="p-mt-3 p-mb-3">
                <label><strong>Formato da Data</strong></label>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-2">
                    <label>Formato</label>
                    <Dropdown v-model="colunasFuncionario.formatoData" :options="formatosData" optionLabel="nome" optionValue="valor"/>
                </div>                        
            </div>
            <div class="p-mt-3 p-mb-3">
                <label><strong>Arquivo CSV de dados</strong></label>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-2">
                    <label>CharSet</label>
                    <Dropdown v-model="colunasFuncionario.charset" :options="charsts" optionLabel="nome" optionValue="valor"/>
                </div> 
                <div class="p-field p-col-12 p-md-12">
                    <label>Funcionários</label>
                    <FileUpload :customUpload="true" name="dados[]" accept=".csv" :multiple="false"
                    uploadLabel="Enviar" cancelLabel="Cancelar" chooseLabel="Selecionar CSV..." @uploader="enviar">
                    <template #empty>
                        <p>Arraste e solte o arquivo aqui para importar. Selecione somente um arquivo.</p>
                    </template>
                    </FileUpload>
                </div>                   
            </div>
        </template>
        <template #footer>
            <div class="p-grid p-nogutter p-jc-start">
                <Button label="Voltar" @click="anterior" icon="pi pi-angle-left" class="p-mr-2" />
                <Button label="Cancelar" @click="cancelar" icon="pi pi-times" class="p-button-secondary" />
            </div>            
        </template>
    </Card>
  </div>
</template>

<script>

import FuncionarioService from '@/service/FuncionarioService';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
    funcionarioService: null,
    data() {
        return {
            posicoesColunas: [],
            colunasFuncionario: {},
            charsts: [{nome: 'UTF-8', valor: 'UTF-8'}, {nome: 'ISO-8859-1', valor: 'ISO-8859-1'}],     
            formatosData: [{nome: 'dia/mes/ano', valor: 'dd/MM/yyyy'}, {nome: 'ano-mes-dia', valor: 'yyyy-MM-dd'}],         
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),       
        enviar(event) {         
            let mapNomes = new Map();
            mapNomes.set('posicaoColunaNome', 'Nome');
            mapNomes.set('posicaoColunaPis', 'Pis');
            mapNomes.set('posicaoColunaCpf', 'Cpf');
            mapNomes.set('posicaoColunaCracha', 'Crachá');
            mapNomes.set('posicaoColunaRegistro', 'Registro');
            mapNomes.set('posicaoColunaDataAdmissao', 'Data de Admissão');
            mapNomes.set('posicaoColunaCargo', 'Cargo');
            mapNomes.set('posicaoColunaCentroCusto', 'Centro de Custo');
            mapNomes.set('posicaoColunaSenhaBiometria', 'Senha Biometria');
            mapNomes.set('posicaoColunaDataNascimento', 'Data de Nascimento');
            mapNomes.set('posicaoColunaEmail', 'E-mail');
            let erro = false;
            sairGeral:
            for(let col1 in this.colunasFuncionario) {
                if((col1 == 'posicaoColunaSenhaBiometria' 
                    || col1 == 'posicaoColunaDataNascimento' 
                    || col1 == 'posicaoColunaEmail') && this.colunasFuncionario[col1] == -1) {
                        continue;
                }
                for(let col2 in this.colunasFuncionario) {
                    if(col1 != col2) {
                        if(this.colunasFuncionario[col1] == this.colunasFuncionario[col2]) {
                            exibirMensagemSis(this, 'Coluna '+mapNomes.get(col1)+' igual a coluna '+mapNomes.get(col2), true);
                            this.erro = true;
                            break sairGeral;
                        }
                    }
                }
            }
            if(erro) {
                return;
            }
            let formData = new FormData();
            formData.append('funcionariosStream', event.files[0]);
            formData.append('jsonRequisicao', JSON.stringify({...this.getDadosRequisicao()}));
            formData.append('jsonColunas', JSON.stringify(this.colunasFuncionario));         
            this.funcionarioService.importarCSV(formData)
				.then(resp => {                  
                    sessionStorage.setItem('empregadosArquivoCSV', JSON.stringify(resp.data));
                    this.proximo();
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
        },
        proximo() {
            this.$emit('nextPage', {formData: {}, pageIndex: 0});
        },
        anterior() {
            this.$router.push('/cadastros/funcionarios/importar');
        },
        cancelar() {
            this.$router.push('/cadastros/funcionarios');
        },
        validarColuna(campo) {
            if(this.colunasFuncionario[campo] == -1) {
                this.colunasFuncionario[campo] = 0;
                exibirMensagemSis(this, 'Campo obrigatório', true);
            }
        },
        iniciar() {
            this.posicoesColunas = [
                {pos: 'Selecione', valor: -1},{pos: '1', valor: 0}, {pos: '2', valor: 1}, 
                {pos: '3', valor: 2},{pos: '4', valor: 3}, {pos: '5', valor: 4},  {pos: '6', valor: 5},
                {pos: '7', valor: 6},{pos: '8', valor: 7},{pos: '9', valor: 8},
                {pos: '10', valor: 9}, {pos: '11', valor: 10}, {pos: '12', valor: 11},
                {pos: '13', valor: 12}, {pos: '14', valor: 13}, {pos: '15', valor: 14},
                {pos: '16', valor: 15},{pos: '17', valor: 16},{pos: '18', valor: 17},
                {pos: '19', valor: 18},{pos: '20', valor: 19},                
            ];
            this.colunasFuncionario = {
                posicaoColunaNome: 0,
                posicaoColunaPis: 1,
                posicaoColunaCpf: 2,
                posicaoColunaCracha: 3,
                posicaoColunaRegistro: 4,
                posicaoColunaDataAdmissao: 5,
                posicaoColunaCargo: 6,
                posicaoColunaCentroCusto: 7,
                posicaoColunaSenhaBiometria: -1,
                posicaoColunaDataNascimento: -1,
                posicaoColunaEmail: -1,
                charset: 'ISO-8859-1',
                formatoData: 'dd/MM/yyyy',
            }
        }
    },
    created() {
        this.iniciar();
        this.funcionarioService = new FuncionarioService();
    }
}
</script>

<style>

</style>